module.exports = __webpack_public_path__ + "images/f45ada4bb097c774c5bef80b3575e91f.png";